module.exports = __webpack_public_path__ + "img/SK-NIC2020.be5862e6.png";